import Icon from '@assets/images/Hero-Icone.png';
import {
  SectionWrapper,
  StyledHr,
  ContentWrapper,
  TextBox1,
  TextBox2,
  ImageBox,
  SectionContainer,
} from './AuditEight.style';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const AuditEight = () => {
  const { t } = useTranslation('audit');
  return (
    <SectionContainer>
      <SectionWrapper>
        <h1>{t('auditEight.title')}</h1>
        <StyledHr />
      </SectionWrapper>

      <ContentWrapper>
        <TextBox1>
          <p>
            {t('auditEight.subtitle.spanBefore')}
            <span>2</span>
            {t('auditEight.subtitle.spanAfter')}
          </p>
          <Link to="/contato" className="link-with-icon">
            <button>{t('auditEight.button')}</button>
          </Link>
        </TextBox1>
        <ImageBox>
          <img src={Icon} alt="Imagem" />
        </ImageBox>
      </ContentWrapper>
    </SectionContainer>
  );
};

export default AuditEight;
